import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  prescriptions: [],
  radiologyTests: [],
  diagnosticTests: [],
  referrals: [],
  appointments: [],  // Added appointments array to store appointment data with status
};

const appointmentsActionsSlice = createSlice({
  name: 'appointmentsActions',
  initialState,
  reducers: {
    addPrescription: (state, action) => {
      const { appointmentId, prescription } = action.payload;
      state.prescriptions.push({ appointmentId, prescription });
    },
    addRadiologyTest: (state, action) => {
      const { appointmentId, testDetails } = action.payload;
      state.radiologyTests.push({ appointmentId, testDetails });
    },
    addDiagnosticTest: (state, action) => {
      const { appointmentId, testDetails } = action.payload;
      state.diagnosticTests.push({ appointmentId, testDetails });
    },
    referToAnotherDoctor: (state, action) => {
      const { appointmentId, doctorInfo } = action.payload;
      state.referrals.push({ appointmentId, doctorInfo });
    },
    // Set the status of an appointment
    setAppointmentStatus: (state, action) => {
      const { appointmentId, status } = action.payload;
      const appointment = state.appointments.find(app => app._id === appointmentId);
      if (appointment) {
        appointment.status = status;  // Update the status
      }
    },
    // You can add additional logic if needed (e.g., defaulting to a status if appointment doesn't exist)
  },
});

export const {
  addPrescription,
  addRadiologyTest,
  addDiagnosticTest,
  referToAnotherDoctor,
  setAppointmentStatus, // Export the new action
} = appointmentsActionsSlice.actions;

export default appointmentsActionsSlice.reducer;
